import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { ValidatePositionResponse, StockBySkuResponse, GetFirstPositionResponse } from '../types'

/**
 * API service for relocate operations
 * Centralizes all API calls related to product relocation
 */
export class RelocateApiService {
  /**
   * Validates if a position is valid for a given SKU and product origin
   */
  static validateOriginPosition(positionCode: string, sku: string, productOriginId: number) {
    return axios.get<ValidatePositionResponse>(`${ApiConfig.RelocateApi}/ValidatePosition`, {
      params: { positionCode, sku, productOriginId }
    })
  }

  /**
   * Gets stock information for a SKU in a specific position
   */
  static getStockByPosition(positionCode: string, sku: string, productOriginId: number) {
    return axios.get<StockBySkuResponse[]>(`${ApiConfig.RelocateApi}/GetStockBySku`, {
      params: { skuEan: sku, productOriginId, positionCode }
    })
  }

  /**
   * Validates if a destination position is valid for a given SKU and product origin
   */
  static validateDestinyPosition(positionCode: string, sku: string, productOriginId: number) {
    return axios.get<ValidatePositionResponse>(`${ApiConfig.RelocateApi}/ValidatePosition`, {
      params: { positionCode, sku, productOriginId }
    })
  }

  /**
   * Gets the first available position of a specific type in a zone
   */
  static getFirstPositionByType(zoneId: number, typePositionId: number) {
    return axios.get<GetFirstPositionResponse>(`${ApiConfig.PositionApi}`, {
      params: {
        pageIndex: 0,
        pageSize: 1,
        zoneId,
        typepositionId: typePositionId
      }
    })
  }
}